/* hairUP | Ochrona Przesylki: auto dodanie do koszyka + przelacznik w szufladzie. */
(function () {
  'use strict';

  var drawer = document.getElementById('hu-cart-drawer');
  if (!drawer || drawer.dataset.huProtect === 'true') return;
  drawer.dataset.huProtect = 'true';

  var KEY = 'huProtectOff';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var tried = false;

  function optedOut() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(value) {
    try { sessionStorage.setItem(KEY, value ? '1' : '0'); } catch (e) { /* prywatne okno */ }
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function add(id) { return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); }
  function drop(key) { return post('cart/change.js', { id: key, quantity: 0 }); }

  function repaint() {
    return window.hairUPCart && window.hairUPCart.refresh
      ? window.hairUPCart.refresh()
      : Promise.resolve();
  }

  function frame() { return drawer.querySelector('[data-hu-cart-content]'); }

  function settle() {
    if (busy) return;
    var box = frame();
    if (!box) return;

    var key = box.dataset.protectKey || '';
    var qty = Number(box.dataset.protectQty || 0);
    var others = Number(box.dataset.protectOthers || 0);

    /* Sama ochrona w koszyku bez zadnego produktu nie ma sensu. */
    if (qty > 0 && others === 0 && key) {
      busy = true;
      drop(key).then(repaint).catch(function () {}).finally(function () { busy = false; });
      return;
    }

    if (qty > 0) { tried = false; return; }
    if (others === 0 || optedOut() || tried) return;

    var toggle = drawer.querySelector('[data-hu-protect]');
    if (!toggle) return;

    tried = true;
    busy = true;
    add(toggle.value).then(repaint).catch(function () {}).finally(function () { busy = false; });
  }

  drawer.addEventListener('change', function (event) {
    var toggle = event.target && event.target.closest ? event.target.closest('[data-hu-protect]') : null;
    if (!toggle || busy) return;
    busy = true;
    tried = true;
    setOptOut(!toggle.checked);
    var action = toggle.checked ? add(toggle.value) : drop(toggle.dataset.key);
    action.then(repaint).catch(function () {}).finally(function () { busy = false; });
  });

  new MutationObserver(function () { settle(); }).observe(drawer, { childList: true, subtree: true });
  settle();
})();
